import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { AssignmentStack, UserTimelines } from '@wilson/interfaces';
import { ShiftTimelineDataState } from '@wilson/shift-timeline/state';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'toUserAssignmentStacks',
  standalone: true,
})
export class ToUserAssignmentStacksPipe implements PipeTransform {
  private store = inject(Store);

  transform(user: UserTimelines): Observable<AssignmentStack[] | null> {
    if (user.id) {
      return this.store.select(
        ShiftTimelineDataState.userTimelineAssignmentStacksStream(user.id),
      );
    } else {
      return of(null);
    }
  }
}
